import { Endpoint } from '@business/api/endpoint';
import { TMFeeId, TMFeeResponse } from '@business/entities/tm';
import { TMFeeFormData } from '@modules/settings/SettingsPage/Components/TimeMaterialsTab/AddEditTMFeeModal/AddEditTMFeeModal';

export function fetchTMFees() {
  return Endpoint.get<TMFeeResponse[]>(`@gc/tm-fee`);
}

export function createTMFee(data: TMFeeFormData) {
  return Endpoint.post<TMFeeResponse>(`@gc/tm-fee`, { data });
}

export function updateTMFee(categoryId: TMFeeId, data: TMFeeFormData) {
  return Endpoint.patch<TMFeeResponse>(`@gc/tm-fee/${categoryId}`, { data });
}

export function deleteTMFee(categoryId: TMFeeId) {
  return Endpoint.delete<void>(`@gc/category/${categoryId}`);
}

export function fetchTMFee(categoryId: TMFeeId) {
  return Endpoint.get<TMFeeResponse>(`@gc/tm-fee/type/${categoryId}`);
}
